export default "__VITE_ASSET__BTgJu3qk__"